<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div
    *ngIf="
      aircraftProfileComponentAudits && aircraftProfileComponentAudits.length > 0;
      else noAircraftProfileComponentAudits
    "
  >
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="aircraftProfileComponentAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAircraftProfileComponentAudits> No Aircraft - Component audits </ng-template>

  <div *ngIf="componentAudits && componentAudits.length > 0; else noComponentAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="componentAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noComponentAudits> No Component audits </ng-template>
</ng-template>
